import React from "react";
import { Form, Row, Col } from "react-bootstrap";

export default function SocialTab() {
  return (
    <Row>
      <Col md={6}>
        <Form.Group>
          <Form.Label>Facebook</Form.Label>
          <Form.Control />
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group>
          <Form.Label>LinkedIn</Form.Label>
          <Form.Control />
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group>
          <Form.Label>Twitter</Form.Label>
          <Form.Control />
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group>
          <Form.Label>Instagram</Form.Label>
          <Form.Control />
        </Form.Group>
      </Col>
    </Row>
  );
}